import { BusinessOnboardingDetails } from '@nemuru-eng/js-api-client';

import { BusinessIdentificationEditDialog } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessIdentification/components/BusinessIdentificationEditDialog';
import { BusinessIdentificationForm } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessIdentification/components/BusinessIdentificationForm';
import { useBusinessDetailsActions } from '@/components/modules/KYC/KYCLoan/BusinessKYC/hooks/useBusinessDetailsActions';
import { useBusinessKyc } from '@/components/modules/KYC/KYCLoan/BusinessKYC/hooks/useBusinessKyc';
import { BusinessActions } from '@/components/modules/KYC/KYCLoan/BusinessKYC/types/BusinessActions';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { PendingDataType } from '@/config/types';

interface BusinessIdentificationProps {
  loanId: string;
  businessOnboarding: BusinessOnboardingDetails;
  editModeAllowed?: boolean;
}

export const BusinessIdentification = ({
  loanId,
  businessOnboarding,
  editModeAllowed,
}: BusinessIdentificationProps) => {
  const { opened, toggleDialog, setOpened } = useDialog();
  const { dialogAction, toggleEditModeDialog, businessBaseActionsOptions } = useBusinessDetailsActions({
    editModeAllowed,
    businessOnboarding,
    toggleDialog,
  });

  const { setBusinessDetailsToOnboardingDetails, loading } = useBusinessKyc({ loanId });

  return (
    <SubSectionWrapper
      title={'BUSINESS_IDENTIFICATION'}
      specificActionsOptionsArray={toggleEditModeDialog ? businessBaseActionsOptions : undefined}
    >
      {!businessOnboarding.businessDetails ? (
        <PendingDataWarning type={PendingDataType.BORROWER_ONBOARDING} />
      ) : (
        <>
          <BusinessIdentificationForm businessDetails={businessOnboarding.businessDetails} />
          {opened && dialogAction === BusinessActions.EDIT_DIALOG && (
            <BusinessIdentificationEditDialog
              businessDetails={businessOnboarding}
              opened={opened}
              setOpened={setOpened}
              toggleDialog={toggleDialog}
              loading={loading}
              setBusinessDetailsToOnboardingDetails={setBusinessDetailsToOnboardingDetails}
            />
          )}
        </>
      )}
    </SubSectionWrapper>
  );
};

export enum BusinessIdentificationAction {
  EDIT_DIALOG = 'edit_dialog',
}
